import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  getCurrentMeet
} from 'selectors';


class DatabaseChecker extends Component {
  state = {

  }

  render() {
    const { meet } = this.props;
    if(!meet) {
      return null;
    }

    let foundError = false;

    const errors = {};

    _.each(meet.lifters, (lifter) => {

      if(!errors[lifter._id]) {
        errors[lifter._id] = [];
      }

      _.each(['squat', 'bench', 'dead'], (lift) => {
        _.each(['1', '2', '3'], (attemptNumber) => {
          if(_.isEmpty(_.get(lifter, ['lifts', lift, attemptNumber]))) {
            console.log(lifter);
            errors[lifter._id].push(`Corrupt lifter data for ${lift} ${attemptNumber} - ${lifter._id}`);
            foundError = true;
          }
        });
      });

    });
    console.log(errors);

    return (
      <div className="database-checker">
        { !foundError &&
          <div>
            Everything looks good.
          </div>
        }
        <ul>
          {
            _.map(errors, (lifterErrors, lifterId) => {
              if(_.isEmpty(lifterErrors)) {
                return null;
              }

              return (
                <li key={lifterId}>
                  <ul>
                    {
                      _.map(lifterErrors, (error) => {
                        return (<li key={error}>{error}</li>);
                      })
                    }
                  </ul>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(DatabaseChecker);
